import React from "react";
import { Modal, Table, Button, Badge } from "react-bootstrap";

export default function ViewIssueModal({ show, onHide, doc, onCancel }) {
  if (!doc) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="fw-bold" style={{ color: "#1e3c72" }}>
          Issue Document: #ISSUE-{doc.id}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            <span className="fw-bold text-muted">Issue Date:</span>
            <span>{new Date(doc.created_at).toLocaleString('th-TH')}</span>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="fw-bold text-muted">Reason:</span>
            <div>
              {doc.reason && doc.reason.startsWith('Transfer to branch') ? (
                <Badge bg="info" className="px-2 py-1 me-2">Auto (Transfer)</Badge>
              ) : null}
              <Badge bg="secondary" className="px-2 py-1">{doc.reason}</Badge>
              {doc.status === 'cancelled' && <Badge bg="danger" className="ms-2 px-2 py-1">Cancelled</Badge>}
            </div>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="fw-bold text-muted">Created By:</span>
            <span>{doc.created_by_name || 'System'}</span>
          </div>
        </div>

        <h6 className="fw-bold mb-3 border-bottom pb-2">Issued Items</h6>
        
        <Table bordered hover size="sm" className="align-middle">
          <thead className="bg-light">
            <tr>
              <th width="15%">Type</th>
              <th width="45%">Product / Item</th>
              <th width="20%" className="text-center">Quantity</th>
              <th width="20%" className="text-end">Cost (฿)</th>
            </tr>
          </thead>
          <tbody>
            {doc.items && doc.items.map((item) => (
              <tr key={item.id}>
                <td>
                  <Badge bg={item.type === 'product' ? 'info' : 'warning'}>
                    {item.type === 'product' ? 'Product' : 'Item'}
                  </Badge>
                </td>
                <td>{item.name}</td>
                <td className="text-center fw-bold">
                  {item.quantity} <span className="text-muted fw-normal small">{item.unit || ''}</span>
                </td>
                <td className="text-end">{Number(item.cost).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3" className="text-end fw-bold">Total Cost:</td>
              <td className="text-end fw-bold text-danger">
                {Number(doc.total_cost).toLocaleString('en-US', { minimumFractionDigits: 2 })}
              </td>
            </tr>
          </tfoot>
        </Table>
      </Modal.Body>
      <Modal.Footer className="bg-light d-flex justify-content-between">
        {doc.status !== 'cancelled' ? (
          <Button variant="outline-danger" onClick={() => onCancel(doc.id)}>
            ยกเลิกใบเบิก (Void)
          </Button>
        ) : (
          <div></div>
        )}
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
